module.exports = __webpack_public_path__ + "static/media/Steklo.5edbdc85.png";